/* eslint-disable react/jsx-max-depth */
import React from 'react';
import styled from 'styled-components';
import { SvgWrapper } from '../svg-wrapper';
var Svg = /*#__PURE__*/styled(SvgWrapper).withConfig({
  displayName: "checked-icon__Svg",
  componentId: "dmnnad-0"
})(["width:32px;height:32px;color:", ";polyline{stroke:", ";}"], p => p.theme.colors.primary500, p => p.theme.colors.contrastingBrandColor);
export var Checked = (_ref) => {
  var {
    className
  } = _ref;
  return /*#__PURE__*/React.createElement(Svg, {
    viewBox: "0 0 32 32",
    className: className
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    /* eslint-disable-next-line max-len */
    d: "M16,0 C7.163444,0 0,7.163444 0,16 C0,24.836556 7.163444,32 16,32 C24.836556,32 32,24.836556 32,16 C32,7.163444 24.836556,0 16,0 Z M16,2.4 C23.5110726,2.4 29.6,8.4889274 29.6,16 C29.6,23.5110726 23.5110726,29.6 16,29.6 C8.4889274,29.6 2.4,23.5110726 2.4,16 C2.40817683,8.49231696 8.49231696,2.40817683 16,2.4 L16,2.4 Z",
    id: "checked-path-1"
  })), /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1249.000000, -3598.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(99.000000, 3088.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.000000, 454.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(901.000000, 40.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(248.000000, 16.000000)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "checked-mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#checked-path-1"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "currentColor",
    fillRule: "nonzero",
    xlinkHref: "#checked-path-1"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#checked-mask-2)",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("rect", {
    x: "0",
    y: "0",
    width: "32",
    height: "32"
  })), /*#__PURE__*/React.createElement("circle", {
    fill: "currentColor",
    fillRule: "nonzero",
    cx: "16",
    cy: "16",
    r: "13.6"
  })), /*#__PURE__*/React.createElement("polyline", {
    stroke: "#FFFFFF",
    strokeWidth: "3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    transform: "translate(16.000000, 13.600000) rotate(135.000000) translate(-16.000000, -13.600000) ",
    points: "8 8.8 24 8.8 24 18.4"
  }))))))));
};